import StudentCabinet from './StudentCabinet';

export default StudentCabinet;
